import md5 from 'md5';
import { Image } from './ApiList';
import { message } from 'antd';

const { store } = Image;
const ImageStoreUrl = store.url;

const URL = require('./url.js').default;
const base64 = require('./base64.js');

const styles = {
  // "original": "saveexif,1",
  "original": "",
  "watermark_h": "resize,m_lfit,w_3840",
  "watermark_v": "resize,m_lfit,w_2560",
  "weixin_120": "resize,m_fill,w_120,h_80,limit_1/auto-orient,0/sharpen,100/quality,q_90/format,jpg/interlace,1",
  "avatar_150": "resize,m_fill,w_150,h_150,limit_1/auto-orient,1/sharpen,100/quality,Q_90/format,jpg/interlace,1",
  "thumb_150": "resize,m_lfit,w_150,h_150,limit_1",
  "origin_150": "resize,m_fill,w_150,h_150,limit_1",
  "wx_170_210": "resize,m_fill,w_170,h_210,limit_1/auto-orient,0/sharpen,100/format,jpg/interlace,1",
  "wx_690_170": "resize,m_fill,w_690,h_170,limit_0/auto-orient,0/sharpen,100/format,jpg/interlace,1",
  "wx_750_435": "resize,m_fill,w_750,h_435,limit_1/auto-orient,0/sharpen,100/format,jpg/interlace,1",
  "wx_110_85": "resize,m_fill,w_220,h_170,limit_1/auto-orient,0/sharpen,100/format,jpg/interlace,1",
  "wx_560_n": "resize,m_lfit,w_560,limit_1/auto-orient,1/format,jpg/interlace,1",
  "wx_750_n": "resize,m_lfit,w_1365,limit_1/auto-orient,1/quality,Q_90/format,jpg/interlace,1",
  "wx_1920_n": "resize,m_lfit,w_1920,limit_1/auto-orient,1/quality,Q_90/format,jpg/interlace,1",
  "wx_750_320": "resize,m_fill,w_750,h_420,limit_0/auto-orient,0/sharpen,100/quality,Q_90/format,jpg",
  "wx_250_160_top": "resize,m_lfit,w_250,limit_1/auto-orient,1/sharpen,100/format,jpg/crop,x_0,y_0,w_250,h_160,g_north",
  "wx_250_160": "resize,m_lfit,w_250,limit_1/auto-orient,1",
  "wx_375_240": "resize,m_lfit,w_375,limit_1/auto-orient,1/sharpen,100/quality,Q_80/format,jpg",
  "wx_375_240_vertical": "resize,m_lfit,h_482,limit_1/auto-orient,1/sharpen,100/quality,Q_80/format,jpg",
  "wx_108_108": "resize,m_lfit,h_108,limit_1/auto-orient,1/sharpen,100/format,jpg/crop,x_0,y_0,w_108,h_108,g_north",
  "wx_168_168": "resize,m_lfit,h_168,limit_1/auto-orient,1/sharpen,100/format,jpg/crop,x_0,y_0,w_168,h_168,g_north",
  "wx_168_n": "resize,m_lfit,w_168,limit_1/auto-orient,1/sharpen,100/format,jpg",
  // 注意宽高务必在/之前，style方法会用/做划分，如果宽高在后面会导致图片显示不出来，不是很懂为啥
  wx_180_120: 'resize,m_fill,w_180,h_120,limit_0/crop,x_0,y_0,g_north',
  wx_250_350: 'resize,m_fill,w_250,h_350,limit_0/crop,x_0,y_0,g_north',//5:7 用于热门图片的垂直图显示
  wx_555_350: 'resize,m_fill,w_555,h_350,limit_0/crop,x_0,y_0,g_north', //3:2 用于热门图片的水平图显示
  // "wx_690_400": "resize,m_fill,w_690,h_400,limit_0/auto-orient,0/sharpen,100/quality,Q_90/format,jpg",
  "wx_164_200": "resize,m_fill,w_164,h_200,limit_0",
  "wx_750_420": "resize,m_fill,w_750,h_420,limit_0/auto-orient,0/sharpen,100/quality,Q_90/format,jpg",
  "wx_share": "resize,m_fill,w_215,h_168,limit_0/auto-orient,0/sharpen,100/quality,Q_90/format,jpg",
  "redpackage_logo": "resize,m_lfit,h_120,limit_1/auto-orient,1/sharpen,100",
  "background": "",
  "background_ipx": "resize,m_fill,w_750,h_1360,limit_0/quality,Q_100",
  "face": "resize,m_lfit,w_1920,limit_0/auto-orient,1",
  "wx_image_waterfall": "resize,m_fill,w_180,h_180/crop,x_0,y_0,w_180,h_180,g_north/quality,q_90",
  "wx_image_4": "resize,m_fill,w_180,h_180/crop,x_0,y_0,w_180,h_180,g_north/quality,q_90",
  "wx_image_2": "resize,m_fill,w_360,h_240/crop,x_0,y_0,w_360,h_240,g_north/quality,q_90",
  "wx_image_1": "resize,m_lfit,w_750,limit_1/auto-orient,1/quality,Q_90/format,jpg/interlace,1",
  "wx_gallery_mode_1": "resize,m_fill,w_420,h_280",
  "wx_gallery_a_1": "resize,m_lfit,w_420",
  "wx_gallery_mode_2": "resize,m_fill,w_375,h_250",
  "wx_gallery_a_2": "resize,m_lfit,w_375",
  "wx_gallery_mode_3": "resize,m_lfit,w_750",
};

export let getBase64 = function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export let bufferToString = function bufferToString(buffer) {
  var binary = '';
  var bytes = new Uint8Array(buffer);
  var len = bytes.byteLength;
  for (var i = 0; i < len; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return binary;
}

export let cal_file_name = function cal_file_name(file, callback) {
  var fileReader = new FileReader();
  fileReader.onload = function (e) {
    console.time('cal_file_name');
    var buf = e.target.result;
    // var origin = file.size + ':' + file.type + ":";
    // if (buf.byteLength < 1024 * 8) {
    //     origin += bufferToString(buf);
    // } else {
    //     origin += bufferToString(buf.slice(0, 1024));
    //     origin += bufferToString(buf.slice(buf.byteLength>>1, 1024));
    //     origin += bufferToString(buf.slice(buf.byteLength - 1024));
    // }
    // var string = "";
    // if(buf.byteLength < (1024 * 1024)) {
    //   string.push(buf);
    // }else {
    //   string += md5(buf.slice(0, ))
    // }
    // var result = md5(origin);
    // var bytes = new Uint8Array(buf);
    // 最开始，摘要前中后3kb的方式，需要约8ms
    // 全文摘要，需要500ms
    // 现在开始尝试摘段摘取，
    let offset = 0;
    let string = file.size + ':' + file.type + ":";
    let stepSize = 1024 * 5;
    let result = "";
    let count = 0;
    // 500KB以下，直接全文摘要
    if (buf.byteLength < (stepSize * 100)) {
      let uint = new Uint8Array(buf);
      result = md5(uint);
    } else {
      // 最多计算200次，约摸14.5M大小的图片
      while (offset < buf.byteLength && count < 200) {
        let uint = new Uint8Array(buf.slice(offset, stepSize));
        string += md5(uint);
        offset += stepSize * 15;
        count++;
      }
      result = md5(string);
    }
    console.timeEnd('cal_file_name');
    console.log(`计算次数`, count);
    callback(result);
  };
  fileReader.readAsArrayBuffer(file);
}

export let getExt = function getExt(type, name) {
  console.log(`获取文件后缀名`, type, name);
  if (type) {
    switch (type) {
      case "image/jpg":
      //eslint-disable-next-line
      case "image/jpeg": return ".jpg";
      case "image/png": return ".png";
      case "image/gif": return ".gif";
      case "text/csv": return ".csv";
      case "application/vnd.ms-excel": return ".xls";
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": return '.xlsx';
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document": return '.docx';
      case "application/msword": return '.doc';
      case "video/mp4": return ".mp4";
      case "video/mpeg": return ".mpeg";
      case "video/quicktime": return ".mov";
      case "video/x-msvideo": return ".avi";
      case "application/pdf": return '.pdf';
      case "application/vnd.ms-powerpoint": return ".ppt";
      case "application/vnd.ms-powerpoint.presentation.macroenabled.12": return ".pptm";
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation": return ".pptx";
      case "text/plain": return '.txt';
      case "application/zip": return ".zip";
      case "application/x-zip": return ".zip";
      case "application/x-zip-compressed": return '.zip';
      default: return "";
    }
  }
  if (name) {
    let ext = name.substring(name.lastIndexOf('.'));
    let exist = ['.jpg', '.png', '.gif', '.csv', '.xls', '.xlsx', '.docx', '.doc', '.mp4', '.mpeg', '.mov', '.avi', '.pdf', '.ppt', '.pptm', '.pptx', '.zip'].indexOf(ext);

    if (exist > -1) {
      return ext;
    }
    return "";
  }
}

export let getVideoExt = function getVideoExt(type) {
  switch (type) {
    case "video/mp4": return '.mp4';
    default: return "";
  }
}

export let getImageExt = function getImageExt(type) {
  switch (type) {
    case "image/jpg":
    //eslint-disable-next-line
    case "image/jpeg": return ".jpg";
    case "image/png": return ".png";
    case "image/gif": return ".gif";
    default: return "";
  }
}
export let getPhotoSrc = (state, noNext) => {
  if (!state) return "";
  if (state.photoBase64) {
    return state.photoBase64;
  }
  if (state.photo) {
    // return ImageStoreUrl+state.photo+(false===noNext ? "":"!avatar_150");
    return style(state.photo, noNext === false ? '' : 'thumb_150');
  }
  return "";
};
export let formatSign = (sign) => {
  //请务必和自己的uploadParam进行合并
  return {
    //...this.uploadParam,//注意，formatSign的时间节点，由于某些原因，可能在beforeUpload之后会执行
    'policy': sign.policy,
    'OSSAccessKeyId': sign.accessid,
    'success_action_status': '200', // 服务端返回的状态码
    'callback': sign.callback,
    'signature': sign.signature
  };
};
export let beforeUpload = async (file, directory, limitSize) => {
  let error;
  if (!getExt(file.type, file.name)) {
    error = '上传文件格式不支持!';
    message.error(error);
    throw Error(error);
  }
  const isLt20M = file.size / 1024 / 1024 < (limitSize || 20);
  if (!isLt20M) {
    error = '上传文件必须小于' + (limitSize || 20) + 'MB!';
    message.error(error);
    throw Error(error);
  }
  return new Promise((resolve, reject) => {
    !directory && (directory = 'source');
    return cal_file_name(file, (data) => {
      //this.uploadParam.key = ;
      //应当将下面的值赋值给uploadParam.key
      resolve(`${directory}/` + data + getExt(file.type, file.name));
    })
  });
};

export let getSize = function (size, maxLevel = 5) {
  const scale = 1024;
  if (size * 1) {
    var step = ['B', 'KB', 'MB', 'GB', 'TB'];
    var level = 0;
    var result = [];
    while (size > scale && level < maxLevel) {
      var mod = size % scale;
      result.push(mod / scale);
      size = (size - mod) / scale;
      level++;
    }
    if (result && result.length) {
      return (size + result.pop()).toFixed(2) + step[level];
    } else {
      return (size) + step[level];
    }
  } else {
    return '0B';
  }
};

export let formatTime = function (str) {
  if (str) {
    var arr = str.split(' ');
    if (arr[0]) {
      arr[0] = arr[0].replace(/:/ig, '-');
    }
    return Date.parse(arr.join(' '));
  }
  return Date.now();
};

export let getProtocolUrl = (str) => {
  return (str || "").replace(/^http\:/, window.location.protocol);
}

export let getUrl = function (key, style, id) {
  let domainIndex = 1;
  if (key && key.match(/^(http|\/\/)/)) {
    return key + (style ? '!' + style : '');
  }
  if (id && typeof id != undefined && isFinite(id)) {
    domainIndex = Number(id) % 6 + 1;
  }
  var url = window.location.protocol + "//image" + domainIndex + ".jfoto.cn/" + key + (style ? '!' + style : '');
  return url;
};

export let getRawStyleUrl = function (key, style, updatedAt) {
  let url = '';
  if (key && key.match(/^(http|\/\/)/)) {
    url = key;
  } else {
    url = window.location.protocol + `//rawimages.jimage.cn/${key}`;
  }

  let processStyle = false;
  if (style) {
    const customStyle = styles[style];
    if (customStyle) {
      url += "?x-oss-process=image/" + customStyle + (updatedAt ? `&ts=${updatedAt}` : '');
    } else {
      url += "!" + style + (updatedAt ? `?ts=${updatedAt}` : '');
    }
    processStyle = true;
  }
  return url + (!processStyle ? `?ts=${updatedAt}` : '');
};

export let getStyleUrl = function (key, style) {
  let url = '';
  if (key && key.match(/^(http|\/\/)/)) {
    url = key;
  } else {
    url = window.location.protocol + `//image1.jfoto.cn/${key}`;
  }

  if (style) {
    const customStyle = styles[style];
    if (customStyle) {
      url += "?x-oss-process=image/" + customStyle;
    } else {
      url += "!" + style;
    }
  }
  return url;
}

export let getDelayColor = (timestamp = 0) => {
  const minute = Math.floor(timestamp / 1000 / 60);
  if (minute >= 60) {
    return `#d90000`;
  }
  if (minute >= 30) {
    return `#ff5100`;
  }
  if (minute >= 15) {
    return `#ffd130`;
  }
  return `#00c882`;
  // if(minute < 10){
  //     return 'rgb(154, 188, 82)';
  // }else if(minute < 15){
  //     return 'rgb(250, 226, 32)';
  // }else if(minute < 20){
  //     return 'rgb(223, 64, 42)';
  // }else {
  //     return 'rgb(64, 48, 83)';
  // }
}

export const parseRelativePath = (relativePath) => {
  relativePath = relativePath || "";
  let directorys = relativePath.split('/').filter(Boolean);
  let result = {};
  if (directorys && directorys[0]) {
    let parent = directorys[0] || "";
    let data = parent.split('_').filter(Boolean);

    if (data && data.length >= 2) {
      // 有子相册的情况
      result.galleryId = data[0];
      result.galleryName = data[1];

      if (directorys && directorys[1]) {
        // 有子相册且有标签的情况
        result.tagName = directorys[1];
      }
      return result;
    }
    else if (parent) {
      // 没有子相册但有标签的情况
      result.tagName = parent;
      return result;
    }
  }

  return result;
};

export let url = (path, params, id) => {
  const domainIndex = typeof id != 'undefined'
    ? ((id * 1) % 6) + 1
    : 1;
  var result = URL(window.location.protocol + `//image${domainIndex}.jfoto.cn/` + path);
  var query = result.query || {};
  result.setParams(Object.assign(query, params || {}));
  return result.toString(false);
};
// 如果本身的图片url上有?，请自行处理
export const formatImage = function (url, styleName) {
  let postUrl = '';
  if (typeof styles[styleName] !== 'undefined') {
    postUrl = styles[styleName];
  }
  return `${url}?${postUrl}`;
}

export let style = (path, styleName, extra, id) => {
  var result = [];
  if (typeof styles[styleName] != "undefined") {
    result = result.concat(styles[styleName].split("/"));
  }

  // 如果后缀名为.gif，则去掉文件格式的转换，并且去掉水印设置
  if (path && path.match(/\.gif$/ig)) {
    result = result.filter(it => it != 'format,jpg' && it.indexOf('quality,') < 0);
    // delete extra.watermark;
    if (extra) {
      delete extra.watermark;
    }
  }

  if (extra) {
    if (extra.shape) {
      let { width, height, x, y } = extra.shape;
      result.push(scaleShape(x, y, width, height));
    }

    if (extra.watermark_fill) {
      result.push(
        `watermark,image_${base64.safe(extra.watermark_fill)},t_${60},fill_1,padx_100,pady_100`
      );
    }
    else if (extra.watermark) {
      // 兼容：服务端/旧数据可能把 watermark 存成 string（例如 JSON 字符串）
      const normalizeWatermark = (wm) => {
        if (!wm) return null;
        if (wm instanceof Array) return wm;
        if (typeof wm === 'string') {
          const s = wm.trim();
          if (!s) return null;
          // JSON 字符串：[{...}] 或 {...}
          if ((s[0] === '[' && s[s.length - 1] === ']') || (s[0] === '{' && s[s.length - 1] === '}')) {
            try {
              return JSON.parse(s);
            } catch (e) {
              // ignore
            }
          }
          // 非 JSON：当作 icon 路径
          return { icon: s };
        }
        return wm;
      }

      const getWatermarkStyle = (watermark) => {
        // watermark 允许是 icon 字符串
        if (typeof watermark === 'string') {
          watermark = { icon: watermark };
        }
        if (!watermark || !watermark.icon) return null;

        const opacity = (watermark.opacity === 0 || typeof watermark.opacity === 'number')
          ? watermark.opacity
          : 100;
        const align = watermark.align || 'south';

        var icon =
          watermark.icon +
          (watermark.percent
            ? (watermark.icon.indexOf('?') > -1 ? '&' : '?') + "x-oss-process=image/resize,P_" + watermark.percent
            : "");
        var border = watermark.noborder ? 0 : 10;
        var vBorder = border;
        var hBorder = border;
        let borderPercent = 1;
        if (extra.targetWidth) {
          borderPercent = extra.targetWidth / 3840;
        }
        if (typeof watermark.h == 'number') {
          hBorder = Math.round(watermark.h * borderPercent);
        }
        if (typeof watermark.v == 'number') {
          vBorder = Math.round(watermark.v * borderPercent);
        }

        // 注意：这里不能在模板字符串里插入换行/空格，否则会污染 x-oss-process 参数
        return `watermark,image_${base64.safe(icon)},t_${opacity},g_${align},y_${vBorder},x_${hBorder}`;
      }

      let adjust = 'h';
      if (typeof extra.width == 'number' && typeof extra.height == 'number') {
        if (Number(extra.height) > Number(extra.width)) {
          adjust = 'v';
        }
      }

      const watermarkData = normalizeWatermark(extra.watermark);
      if (watermarkData instanceof Array) {
        watermarkData.forEach((watermark) => {
          // 选取行为：
          // - 如果 watermark.adjust 与图片方向(adjust: h/v)一致，则选取
          // - 如果 watermark.adjust 未配置，也会选取（表示通用水印）
          if (watermark && watermark.adjust == adjust) {
            const cfg = getWatermarkStyle(watermark);
            cfg && result.push(cfg);
          } else if (watermark && typeof watermark.adjust == 'undefined') {
            const cfg = getWatermarkStyle(watermark);
            cfg && result.push(cfg);
          }
        });
      } else {
        const cfg = getWatermarkStyle(watermarkData);
        cfg && result.push(cfg);
      }

      // 如果当前请求的还是原图，且要求添加水印时，应该包含exif
      if (styleName == 'original') {
        result.push('saveexif,1');
      }
    }
    if (extra.webp && window.__isSupportWebp) {
      let hasConfigFormat = false;
      result = result.map((cfg) => {
        if (cfg && cfg.indexOf('format,') == 0) {
          cfg = `format,webp`;
          hasConfigFormat = true;
        }

        return cfg;
      });

      if (!hasConfigFormat) {
        result.push(`format,webp`);
      }
    }
  }
  var process = null;
  if (result && result.length) {
    result = result.filter((it) => !!it);
    if (result && result.length) {
      process = {
        "x-oss-process": "image/" + result.join("/"),
      };
    }
  }
  if (path) {
    return url(path, process, id);
  } else {
    return "";
  }
};

export let scaleShape = (x, y, width, height) => {
  // 首先向四个方向，均扩展30像素
  let border = 0.25;
  let min_size = 150;
  let widthBorder = Math.round(width * border);
  let heightBorder = Math.round(height * border);

  width += widthBorder * 2;
  height += heightBorder * 2;

  x -= widthBorder;
  y -= heightBorder;

  // 如果还在小于我们要的尺寸
  if (width < min_size) {
    x -= (min_size - width) / 2;
    width = min_size;
  }
  if (height < min_size) {
    y -= (min_size - height) / 2;
    height = min_size;
  }

  // 把整个图像做成正方形
  if (width < height) {
    let between = height - width;
    x -= between / 2;
    width = height;
  } else if (height < width) {
    height = width;
  }

  return `crop,x_${Math.round(x)},y_${Math.round(y)},w_${Math.round(
    width
  )},h_${Math.round(height)},g_nw`;
}

export let download = (path, name) => {
  return new Promise(resolve => {
    // 确保下载的图片是https的
    if (window.location.protocol === 'https:' && path.startsWith('http:')) {
      path = path.replace('http:', 'https:');
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', path, true);
    xhr.responseType = 'blob';
    xhr.onload = () => {
      if (xhr.status === 200) {
        var urlObject = window.URL || window.webkitURL || window;
        var export_blob = new Blob([xhr.response]);
        var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a');
        save_link.href = urlObject.createObjectURL(export_blob);
        if (!name) {
          let split = path.split('/');
          name = split.pop();
        }
        save_link.download = name;

        window.document.body.appendChild(save_link);
        save_link.click();

        window.document.body.removeChild(save_link);
        resolve();
      }
    };

    xhr.send();
  });
};

export default {
  cal_file_name: cal_file_name,
  bufferToString: bufferToString,
  getBase64: getBase64,
  getExt: getExt,
  getPhotoSrc: getPhotoSrc,
  formatSign: formatSign,
  beforeUpload: beforeUpload,
  getUrl: getUrl,
  formatTime: formatTime,
  getSize: getSize,
  getDelayColor: getDelayColor,
  getStyleUrl: getStyleUrl,
  url,
  style,
  download,
  parseRelativePath
}



// WEBPACK FOOTER //
// ./src/util/image.js